import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  courseClassSubChapTopMapInitialValues,
  courseClassSubChapTopMapMandatoryFields,
  courseClassSubChapTopMapProperties,
  courseClassSubChapTopMapValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { CREATE_YEAR } from "utils/graphql/services/entities/mutations";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getAcademicYearListData } from "utils/metadata-split/metaDataApiFetch";
import {
  CREATE_CHAPTER,
  CREATE_COURSE_CLASS_SUB_CHAP_TOPIC_MAP,
} from "utils/graphql/services/global-content-hierarchy/mutation";
import { shouldDisableButton } from "pages/global-content-hierarchy/helper";

export const CourseClassSubChapTopMapCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    courseClassSubChapTopMapInitialValues,
    courseClassSubChapTopMapValidationSchema,
    ""
  );
  const [createCourseClassSubChapTopMap, { loading, error, data }] =
    useMutation(CREATE_COURSE_CLASS_SUB_CHAP_TOPIC_MAP, {
      client: entitesClient,
    });
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleCreateCourseClassSubChapTopMap = async () => {
    try {
      const response: any = await createCourseClassSubChapTopMap({
        variables: {
          input: {
            status: watch()?.status,
            global_course_id: watch()?.global_course_id,
            global_subject_id: watch()?.global_subject_id,
            global_chapter_id: watch()?.global_chapter_id,
            global_topic_id: watch()?.global_topic_id,
            is_course_hierarchy_enabled:
              watch()?.is_course_hierarchy_enabled == "true" ? true : false,
            is_program_hierarchy_enabled:
              watch()?.is_program_hierarchy_enabled == "true" ? true : false,
            class_id: watch()?.class_id,
          },
        },
      });
      if (
        !isEmpty(
          response?.data?.createCourseClassSubjectChapterTopicMapping?.success
        )
      ) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createCourseClassSubjectChapterTopicMapping?.message}` ||
              `Created Course Class Subject Chapter Topic Map successfully`,
          })
        );
        history.replace(
          `/global-content-hierarchy/course_class_sub_chap_top_map`
        );
      } else {
        dispatch(
          snackbarRequest({
            message:
              `${response?.message}` ||
              `failed to create Course Class Subject Chapter Topic Map`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message:
            `${err}` ||
            `failed to create Course Class Subject Chapter Topic Map`,
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>
        Create Course Class Subject Chapter Topic Mapping
      </TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={courseClassSubChapTopMapProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -1 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateCourseClassSubChapTopMap}
              disabled={!isFieldsValidate(errors, courseClassSubChapTopMapMandatoryFields, getValues)}
              loading={loading}
            >
              Create
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
